import { useKlaviyo } from "@util/hooks";
import React from "react";

interface Props {
  /** Klaviyo embed class, e.g. `klaviyo-form-UdHuPG` from the form install snippet */
  className?: string;
}

/**
 * Empty target div for Klaviyo’s onsite script to hydrate.
 * Footer must stay mounted on client-side navigations — use Gatsby `wrapPageElement` (see wrapApp.tsx).
 */
export default function KlaviyoEmbed({ className }: Props) {
  useKlaviyo();
  const cls =
    className ??
    process.env.GATSBY_KLAVIYO_SUBSCRIBE_FORM_CLASS ??
    "klaviyo-form-QPP5AY";
  return <div className={cls} />;
}
